<template>
    <div>
        <modal
            @before-close="beforeClose"
            @before-open="ensureCompPulled"
            name="comp-modal"
            :min-width="1072"
            :max-width="1072"
            height="auto"
            click-to-close
            scrollable
            adaptive
            draggable=".comp-title-bar">
                <comp v-if="comp != null" :project-data="project" :comp-data="comp" is-modal></comp>
        </modal>
    </div>
</template>

<script>
    export default {
        props: {
            project: {
                type: Object,
                required: true
            },

            compId: {
                type: Number,
                required: false
            }
        },

        data() {
            return { 
                comp: null,
            }
        },

        methods: {
            beforeClose() {
                this.$emit('closed');
            },

            async getComp() {
                await axios.get(`/api/project/${this.project.id}/comp/${this.compId}`).then(response => {
                    this.comp = response.data.comp;
                });
            },

            async ensureCompPulled() {
                this.comp = null;

                await this.getComp();
            }
        }
    }
</script>